import { Button, Input, Radio } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .ant-form-item-label {
    font-size: 14px;
    font-weight: 700;
    line-height: 19px;
  }

  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }

  .ant-radio {
    top: 0;
  }
`;

interface InputProps {
  isErrored?: boolean;
}

export const InputStyled = styled(Input)<InputProps>`
  border-radius: 4px;
  height: 50px;
  font-size: 14px;
  border: 1px solid #EDEDED;
  box-shadow: none;

  &:hover,
  &:focus,
  &:active,
  &:focus-within {
    border-color: #00ab6b;
  }

  ${(props) => props.isErrored && `
    border-color: #EE4A49;

    &:hover,
    &:focus,
    &:active,
    &:focus-within {
      border-color: #EE4A49 !important;
    }
  `}
`;

export const InputError = styled.div`
  color: #EE4A49;
  font-size: 12px;
  line-height: 19px;
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 4px;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const CharCount = styled.span<InputProps>`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  line-height: 19px;
  color: #858585;

  ${(props) => props.isErrored && `
    color: #EE4A49;
  `}
`;

export const NextButton = styled(Button)`
  width: 100%;
  height: 44px;
  border-radius: 4px;
  font-family: ProximaNovaRg;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  cursor: pointer;
`;

export const StyledRadioGroup = styled(Radio.Group)`
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
    width: min-content;
    text-wrap: nowrap;
  }

  .ant-radio {
    display: inline-flex;
    align-items: center;
  }

  /* Default radio button styling */
  .ant-radio-inner {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid #CBCBCB;
    position: relative;
    transition: none;
    animation: none;
  }

  /* Hide default pseudo-element */
  .ant-radio-inner::before {
    display: none;
  }

  /* Checked state: green circle with checkmark */
  .ant-radio-checked .ant-radio-inner {
    border-color: #00AB6B;
    background-color: #00AB6B;
  }

  /* Add checkmark when checked */
  .ant-radio-checked .ant-radio-inner::after {
    content: "";
    position: absolute;
    display: block;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    top: 1px;
    left: 5px;
    transform: rotate(45deg);
  }

  .ant-radio-inner::after {
    transition: none;
  }
`;
